<template>
  <layout-basic>
    <v-container fluid>
      <v-layout row wrap>
        <v-row style="margin-bottom: 44px">
          <v-col cols="12" md="4">
            <v-card flat height="100%">
              <v-card-text class="px-0">
                <h3>User Statistics - Number of customer logins by month</h3>
                <apexchart
                  :options="lineChartOptions"
                  :series="lineSeries"
                  type="line"
                  height="350"
                  v-if="!reportLoading"
                />
                <div class="text-center" v-else  fluid style="position: relative;width: 100%;margin-top: 25px;">
                  <v-skeleton-loader class="mx-auto mt-5" type="image"></v-skeleton-loader>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card flat height="100%">
              <v-card-text class="px-0">
                <h3>Most Popular Courses</h3>
                <apexchart
                  :options="barChartOptions"
                  :series="barSeries"
                  type="bar"
                  height="350"
                  v-if="!reportLoading"
                />
                <div class="text-center" v-else  fluid style="position: relative;width: 100%;margin-top: 25px;">
                  <v-skeleton-loader class="mx-auto mt-5" type="image"></v-skeleton-loader>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card flat height="100%">
              <v-card-text class="px-0">
                <h3>Completed Courses</h3>
                <apexchart
                  :options="pieChartOptions"
                  :series="pieChart.series"
                  type="donut"
                  height="350"
                  width="380"
                  v-if="!reportLoading"
                />
                <div class="text-center" v-else  fluid style="position: relative;width: 100%;margin-top: 25px;">
                  <v-skeleton-loader class="mx-auto mt-5" type="image"></v-skeleton-loader>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-layout>
      <v-layout row wrap>
        <v-row style="margin-bottom: 44px">
          <v-col cols="12" sm="6" md="3">
            <v-card
              class="text-xs-center px-0 mx-auto"
              height="100%"
              @click="redirect('user')"
            >
              <v-card-text>
                <v-img
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin: 0 auto"
                  contain
                  src="/static/chart.png"
                ></v-img>
                <h3>User Reports</h3>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card
              class="text-xs-center px-0 mx-auto"
              height="100%"
              @click="redirect('course')"
            >
              <v-card-text>
                <v-img
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin: 0 auto"
                  contain
                  src="/static/chart.png"
                ></v-img>
                <h3>Course Reports</h3>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card
              class="text-xs-center px-0 mx-auto"
              height="100%"
              @click="redirect('groups')"
            >
              <v-card-text>
                <v-img
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin: 0 auto"
                  contain
                  src="/static/chart.png"
                ></v-img>
                <h3>Group Reports</h3>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card
              class="text-xs-center px-0 mx-auto"
              height="100%"
              @click="redirect('playlist')"
            >
              <v-card-text>
                <v-img
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin: 0 auto"
                  contain
                  src="/static/chart.png"
                ></v-img>
                <h3>Playlist Reports</h3>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from '@/layouts/PartnerHub';
import VueApexCharts from 'vue-apexcharts';
import partnerAPI from '@/api/partner.js';

export default {
  components: {
    LayoutBasic,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      id: this.$route.params.id,
      line: {},
      bar: {},
      pie: {},
      pieChart: {
        series: [0],
      },
      lineSeries: [
        {
          name: 'Logins',
          data: [0],
        },
      ],
      lineChartOptions: {
        chart: {
          height: 150,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [1],
        },
      },
      reportLoading: false,
      companyName: ''
    };
  },
  mounted() {
    this.getReports();
  },
  computed: {
    lineChartY() {
      return this.line.logins.map((x) => {
        return x;
      });
    },
    lineChartX() {
      return this.line.months.map((x) => {
        return x;
      });
    },
    barSeries() {
      return [
        {
          name: 'Total Users',
          data: this.bar.series,
        },
      ];
    },
    barChartOptions() {
      return {
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        xaxis: {
          categories: this.bar.categories,
          tickAmount: 3,
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        },
        chart: {
        toolbar: {
            show: true,
            tools: {
              download: true
            },
            export: {
              csv: {
                filename: `Most_Popular_Courses_${this.companyName}_${new Date().toISOString().slice(0, 19).replace(/[-T:]/g, "_")}`, // Custom filename
                columnDelimiter: ",",
                headerCategory: "Courses", // Custom X-axis title
                headerValue: "Total Users Assigned", // Custom Y-axis title
              }
           }
          },
        },
      };
    },
    pieChartOptions(){
      return {
        dataLabels: {
            enabled: false,
          },
          labels: ['Not Started', 'Completed', 'In progress'],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 230,
          },
          chart: {
            toolbar: {
              show: true,
                tools: {
                  download: true,
                },
                export: {
                  csv: {
                    filename: `Completed_Course__${this.companyName}_${new Date().toISOString().slice(0, 19).replace(/[-T:]/g, "_")}`,
                    columnDelimiter: ",",
                    headerCategory: "Course Status",
                    headerValue: "Total Users"
                  },
                  svg: {
                    filename: `Completed_Course_SVG__${this.companyName}_${new Date().toISOString().slice(0, 19).replace(/[-T:]/g, "_")}`,
                  },
                  png: {
                    filename: `Completed_Course_PNG__${this.companyName}_${new Date().toISOString().slice(0, 19).replace(/[-T:]/g, "_")}`,
                  }
                }
              },
            }
      }
    }
  },
  methods: {
    lineChart() {
      this.lineChartOptions = {
        xaxis: {
          categories: this.lineChartX,
        },
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false
            },
            export: {
              csv: {
                filename: `User_Statistics_${this.companyName}_${new Date().toISOString().slice(0, 19).replace(/[-T:]/g, "_")}`, // Custom filename with timestamp
                columnDelimiter: ",",
                headerCategory: "Month", // Custom X-axis title
                headerValue:  this.lineSeries[0].name, // Custom Y-axis title
              }
           }
          },
        },
      };
      this.lineSeries = [
        {
          name: "Logins",
          data: this.lineChartY,
        },
      ];
    },
    getReports() {
      this.reportLoading = true;
      partnerAPI.geCustomerReports(this.$route.params.id).then((response) => {
        this.reportLoading = false;
        this.companyName = response.data.company_name;
        if(response.data.line){
          this.line = response.data.line;
          this.lineChart();
        }
        if(response.data.bar)
          this.bar = response.data.bar;
        
          let pieChartSeries = response.data.pie.map((x) => {
                    return x;
                })
          this.pieChart.series = pieChartSeries
      });
    },
    redirect(type) {
      this.$router.push('/partner/reports/customer/' + this.id + '/' + type);
    },
  },
};
</script>
